import React, { useEffect } from 'react';
import { FEATURE_REDO_SHORTCUT, FEATURE_UNDO_SHORTCUT } from '../flags';
import { isEventTargetInputElement } from '../utils/is-event-target-input-element';
import { useWriteContext } from '../utils/use-context';
import {historyShortcut} from '@waka/compat/history-shortcut';

export const UndoRedo: React.FC = () => {
  const { undo, redo } = useWriteContext();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // target이 input이면 trigger하지 않음
      if (isEventTargetInputElement(e)) {
        return;
      }

      const command=historyShortcut(e);
      // Shift produces uppercase Z on actual keyboards.
      if (
        command==='undo' &&
        FEATURE_UNDO_SHORTCUT
      ) {
        e.preventDefault();
        undo();
      }

      // Redo: Cmd+Shift+Z (Mac) 또는 Ctrl+Y (Windows/Linux) 또는 Ctrl+Shift+Z
      if (
        command==='redo' && FEATURE_REDO_SHORTCUT
      ) {
        e.preventDefault();
        redo();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [undo, redo]);

  return null;
};
